.section {
  min-height: auto;
  overflow: clip;
}

.motionRoot {
  padding-block: calc(var(--space-xl) * 0.85)
    calc(var(--space-2xl) * 0.85);
  overflow: clip;
  background: var(--color-background);
}

.intro {
  display: flex;
  width: min(calc(100% - (var(--page-margin) * 2)), 52rem);
  margin-inline: auto;
  align-items: center;
  flex-direction: column;
  gap: var(--space-xs);
  text-align: center;
  text-shadow: 0 0.125rem 1.5rem rgb(0 0 0 / 72%);
}

.title {
  margin-top: 0.5rem;
  font-size: clamp(2.5rem, 4vw, var(--font-size-section));
  font-weight: var(--font-weight-semibold);
  letter-spacing: -0.01em;
  line-height: var(--line-height-section);
  text-wrap: balance;
}

.subtitle {
  color: var(--color-text-primary);
  font-size: clamp(1.125rem, 1.75vw, var(--font-size-subheading));
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-subheading);
  text-wrap: balance;
}

.body,
.data {
  color: var(--color-text-secondary);
  line-height: var(--line-height-body);
}

.body {
  max-width: 42rem;
}

.data {
  width: min(100%, 30rem);
  margin-top: var(--space-xs);
  padding-top: var(--space-xs);
  border-top: 1px solid rgb(255 255 255 / 14%);
  color: var(--color-text-primary);
}

.carouselViewport {
  width: 100vw;
  margin-top: calc(var(--space-2xl) * 0.85);
  margin-left: calc(50% - 50vw);
  overflow: hidden;
}

.carouselTrack {
  display: flex;
  gap: var(--space-s);
  align-items: flex-start;
  padding-inline: max(
    var(--page-margin),
    calc((100vw - var(--container-max)) / 2 + var(--page-margin))
  );
  overflow-x: auto;
  overscroll-behavior-inline: contain;
  scrollbar-width: none;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  touch-action: pan-x pan-y;
  cursor: grab;
}

.carouselTrack::-webkit-scrollbar {
  display: none;
}

.carouselTrack:focus-visible {
  outline: 1px solid rgb(255 255 255 / 36%);
  outline-offset: 0.5rem;
}

.carouselTrack.isDragging {
  scroll-snap-type: none;
  scroll-behavior: auto;
  cursor: grabbing;
}

.carouselCard {
  flex: 0 0 clamp(22rem, 38vw, 40rem);
  margin: 0;
  scroll-snap-align: start;
}

.imageButton {
  display: block;
  width: 100%;
  aspect-ratio: 3 / 4;
  padding: 0;
  overflow: hidden;
  border: 0;
  border-radius: clamp(0.75rem, 1vw, 1rem);
  background: #0a0a0a;
  box-shadow: 0 1.5rem 4rem rgb(0 0 0 / 36%);
  color: inherit;
  cursor: zoom-in;
}

.cardImage {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  transition: filter var(--duration-normal) cubic-bezier(0.22, 1, 0.36, 1);
  user-select: none;
}

.caption {
  display: flex;
  margin-top: var(--space-xs);
  flex-direction: column;
  gap: 0.375rem;
}

.captionTitle {
  color: var(--color-text-secondary);
  font-size: var(--font-size-caption);
  font-weight: var(--font-weight-light);
  letter-spacing: 0.14em;
  line-height: 1.5;
}

.captionHint {
  color: var(--color-text-muted);
  font-size: 0.6875rem;
  font-weight: var(--font-weight-light);
  letter-spacing: 0.08em;
  line-height: 1.4;
}

.lightbox {
  position: fixed;
  z-index: var(--z-modal);
  inset: 0;
  display: grid;
  padding: clamp(1rem, 4vw, 4rem);
  background: rgb(5 5 5 / 88%);
  backdrop-filter: blur(18px);
  place-items: center;
  animation: lightboxFadeIn 260ms ease both;
}

.lightboxFigure {
  display: flex;
  width: 100%;
  height: 100%;
  margin: 0;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: var(--space-xs);
  animation: lightboxScaleIn 320ms cubic-bezier(0.22, 1, 0.36, 1) both;
}

.lightboxClosing {
  animation: lightboxFadeOut 260ms ease both;
}

.lightboxClosing .lightboxFigure {
  animation: lightboxScaleOut 260ms ease both;
}

.lightboxImage {
  display: block;
  width: auto;
  max-width: calc(100vw - 2rem);
  height: auto;
  max-height: calc(100svh - 8rem);
  object-fit: contain;
}

.lightboxImage[data-wechat-protected-media] {
  width: min(calc(100vw - 2rem), calc((100svh - 8rem) * 0.7488));
  height: auto;
}

.lightboxCaption {
  width: 100%;
  color: var(--color-text-primary);
  font-size: var(--font-size-caption);
  font-weight: var(--font-weight-light);
  letter-spacing: 0.14em;
  text-align: left;
}

.lightboxClose {
  position: absolute;
  z-index: 1;
  top: clamp(1rem, 3vw, 2.5rem);
  right: clamp(1rem, 3vw, 2.5rem);
  width: 2.75rem;
  height: 2.75rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: white;
  cursor: pointer;
}

.lightboxClose span::before,
.lightboxClose span::after {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1.75rem;
  height: 1px;
  background: currentColor;
  content: '';
}

.lightboxClose span::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.lightboxClose span::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

@keyframes lightboxFadeIn {
  from {
    opacity: 0;
  }
}

@keyframes lightboxFadeOut {
  to {
    opacity: 0;
  }
}

@keyframes lightboxScaleIn {
  from {
    opacity: 0;
    transform: scale(0.975);
  }
}

@keyframes lightboxScaleOut {
  to {
    opacity: 0;
    transform: scale(0.985);
  }
}

@media (hover: hover) and (pointer: fine) {
  .imageButton:hover .cardImage {
    filter: brightness(1.06);
  }
}

@media (min-width: 48rem) and (max-width: 63.9375rem) {
  .motionRoot {
    padding-block: clamp(var(--space-m), 7vw, var(--space-l))
      clamp(var(--space-l), 10vw, 7rem);
  }

  .carouselViewport {
    margin-top: clamp(var(--space-m), 8vw, var(--space-l));
  }

  .carouselCard {
    flex-basis: clamp(20rem, 42vw, 27rem);
  }
}

@media (max-width: 47.9375rem) {
  .motionRoot {
    padding-block: 2.5rem var(--space-m);
  }

  .intro {
    width: 100%;
    padding-inline: var(--page-margin);
  }

  .title {
    font-size: var(--font-size-section);
  }

  .subtitle {
    font-size: var(--font-size-subheading);
  }

  .carouselTrack {
    gap: var(--space-s);
    padding-inline: 0 var(--page-margin);
  }

  .carouselViewport {
    margin-top: var(--space-m);
  }

  .carouselCard {
    flex-basis: 77vw;
  }

  .captionTitle,
  .captionHint {
    padding-left: var(--page-margin);
  }

  .captionTitle {
    font-size: max(var(--font-size-caption), 0.75rem);
  }
}

@media (prefers-reduced-motion: reduce) {
  .carouselTrack {
    scroll-behavior: auto;
  }

  .cardImage,
  .lightbox,
  .lightboxFigure,
  .lightboxClosing,
  .lightboxClosing .lightboxFigure {
    transition: none;
    animation: none;
  }
}
